import {
  NavigableAnnotationPopoverProps,
  useNavigationContext,
} from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { InvoiceDiscrepancy } from 'services/invoiceDiscrepancies/types';
import { InfoPopover } from 'components/InfoPopover/InfoPopover';

import { WithErrorsContent } from './components/WithErrorsContent';

type DiscrepanciesModalProps = NavigableAnnotationPopoverProps<InvoiceDiscrepancy>;

export const DiscrepanciesModal = ({ style, annotation, ref }: DiscrepanciesModalProps) => {
  const { service } = useNavigationContext<InvoiceDiscrepancy>();
  const numberOfErrors = service.useNumberOfActiveItems();

  if (!annotation) {
    return null;
  }

  return (
    <InfoPopover ref={ref} style={style}>
      <WithErrorsContent error={annotation} numberOfErrors={numberOfErrors} />
    </InfoPopover>
  );
};
